import { Box, CircularProgress } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import React, { useState } from "react"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { FilterCheckbox } from "@/components/common/Filters"
import { InputField } from "@/components/common/InputField"
import type { ClassificationQueryableFields } from "@/graphql/codegen/graphql"
import useProductCategory from "@/screens/ManageProducts/components/ProductCategories/hooks/useProductCategory"
import useDebounce from "@/utils/useDebounce"

interface ProductCategoryProps {
  onFilterChange: (name: keyof ClassificationQueryableFields, value: any) => void
}

export const ProductCategoryFilter: FC<ProductCategoryProps> = ({ onFilterChange }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const { control, watch } = useFormContext()
  const categoriesValue = watch("categoryIds") || []
  const debouncedSearchString = useDebounce(searchTerm, 300)

  const { productCategoryList, productCategoryListFetching } = useProductCategory({ query: debouncedSearchString })

  const handleFilterChange = (newValue: string[]) => {
    onFilterChange("categoryIds", newValue)
  }

  return (
    <>
      <Box className='p-4'>
        <InputField
          placeholder='Search by Category Name'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          startAdornment={<SearchOutlined className='text-gray-600' />}
          endAdornment={productCategoryListFetching && <CircularProgress size={20} />}
        />
      </Box>

      <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
        {productCategoryList.map((category) => (
          <FilterCheckbox
            key={category.categoryId}
            label={category.name}
            value={category.categoryId}
            control={control}
            name='categoryIds'
            values={categoriesValue}
            onFilterChange={handleFilterChange}
          />
        ))}

        {productCategoryListFetching && (
          <Box display='flex' justifyContent='center' py={2}>
            <CircularProgress size={24} />
          </Box>
        )}
      </Box>
    </>
  )
}
